
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/digital-tools/tracking-system",
      function () {
        return require("private-next-pages/digital-tools/tracking-system/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/digital-tools/tracking-system"])
      });
    }
  